import { moments } from '../utils/index'

export default {
  rooms(state) {
    return state.summary.rooms
  },
  room: state => no => state.summary.rooms.filter(r => r.no === no)[0],
  room_by_id: state => id => state.summary.rooms.filter(r => r._id === id)[0],
  get_room_no: (state, getters) => id => {
    const room = getters.room_by_id(id)
    if (room)
      return room.no
  },
  room_price: (state, getters) => no => {
    const room = getters.room(no)
    if (room && room.price_month != null)
      return room.price_month
    else if (room && room._type) {
      const type = getters.roomtype(room._type)
      if (type && type.price_month != null)
        return type.price_month
    }
    return null
  },
  room_state: (state, getters) => no => {
    const room = getters.room(no)
    if (!room) return 'unknown'

    if (!room.avaliable)
      return 'unavaliable'

    const contract = getters.current_contract_of_room(no)
    let room_state = contract ? 'checked' : 'avaliable'
    if (contract && contract.state === 'delegated')
      room_state = contract.state
    return room_state
  },
  room_categories: state => Array.from(new Set(state.summary.rooms.map(r => r.category))),
  properties: state => state.summary.properties,
  property: state => id => state.summary.properties.filter(p => p._id === id)[0],
  /* eslint-disable arrow-body-style */
  properties_of_room: (state, getters) => properties => {
    return properties.map(
      (prop) => Object.assign({}, getters.property(prop._id), {
        quantity: prop.quantity,
        variant: prop.variant,
        note: prop.note,
      })
    ).sort((a, b) => {
      let result = (a.name || '').localeCompare(b.name || '')
      if (result === 0)
        result = (a.category || '').localeCompare(b.category || '')
      return result
    })
  },
  customers: state => state.summary.customers,
  customers_filter: state => id_list => state.summary.customers.filter(c => id_list.includes(c._id)),
  roomtypes(state) {
    return state.summary.roomtypes
  },
  roomtype: state => id => state.summary.roomtypes.filter(r => r._id === id)[0],
  contracts(state) {
    return state.summary.contracts
  },
  terminate_contracts(state) {
    return state.summary.contracts.filter(c => !c._next_contract)
  },
  contract: state => id => state.summary.contracts.filter(c => c._id === id)[0],
  preorder: state => id => state.summary.preorders.filter(p => p._id === id)[0],
  preorders_of_room: (state, getters) => no => {
    const preorders = []
    const room = getters.room(no)
    if (room) return state.summary.preorders.filter(p => p._room === room._id)
    return []
  },
  contract_state: (state, getters) => id => {
    const contract = getters.contract(id)
    if (!contract) return 'unknown'

    const start = moments(contract.date_start).utc().startOf('day')
    const end = moments(contract.date_end).utc().startOf('day')
    const now = moments().utc().startOf('day')

    if (now < start)
      return 'notactive'
    else if (start <= now && now < end)
      return 'active'
    return 'expired'
  },
  contracts_of_room: (state, getters) => no => {
    const contracts = []
    const room = getters.room(no)
    if (room) return state.summary.contracts.filter(c => c._room === room._id)
    return []
  },
  current_contracts: (state, getters) => {
    const contracts = getters.contracts
    return contracts.filter(c => c.state === 'active' || c.state === 'delegated')
  },
  current_contract_of_room: (state, getters) => no => {
    const contracts = getters.contracts_of_room(no)
    const avaliable = contracts.filter(c => c.state === 'active' || c.state === 'delegated')
    if (avaliable.length)
      return avaliable[0]
    return null
  },
  contracts_chain: (state, getters) => contract => {
    if (!contract)
      return []
    let contracts = [contract]
    if (contract._previous_contract) {
      const prev_one = getters.contract(contract._previous_contract)
      contracts = getters.contracts_chain(prev_one).concat(contracts)
    }
    return contracts
  },
  charges_of_contracts: (state, getters) => contracts => {
    const ids = contracts.map(c => c._id)
    return state.summary.charges.filter(c => ids.indexOf(c._contract) >= 0)
  },
  customers_of_contract: (state, getters) => contract => {
    if (contract && contract._customers)
      return getters.customers_filter(contract._customers)
    return []
  },
  draft: (state) => (type) => ({
    keys: () => Object.keys(state.drafts[type] || {}).filter(k => (state.drafts[type] || {})[k] !== undefined),
    load: (key) => (state.drafts[type] || {})[key],
  }),
  pending_bills: state => state.summary.pending_bills,

  username: state => _id => {
    const info = state.summary.usernames.filter(u => u._id === _id)[0]
    if (!info) return ''
    return info.display || info.username
  },
}



// WEBPACK FOOTER //
// ./client/src/store/getters.js